import { Box, BoxProps } from '@mui/material';

/**
 * The shell's content padding, in theme spacing units. Exported because PageShell is the
 * scroll container: anything inside that pins with `position: sticky` (e.g. a stickyHeader
 * table) pins to the content box and must cancel this padding with a matching negative
 * `top` offset. Consumers referencing this constant stay correct if the padding changes.
 */
export const PAGE_SHELL_PADDING = 4;

interface PageShellProps extends BoxProps {
  children: React.ReactNode;
  maxWidth?: number | 'none';
}

export default function PageShell({ children, maxWidth = 'none', sx, ...rest }: PageShellProps) {
  return (
    <Box
      sx={{
        height: '100%',
        overflow: 'auto',
        maxWidth: maxWidth === 'none' ? undefined : maxWidth,
        mx: 'auto',
        p: PAGE_SHELL_PADDING,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
}
